var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        ref: "inputSlot",
        staticClass: "input-wrapper",
        on: { input: _vm.onInput, keyup: _vm.onListKeyUp }
      },
      [
        _c(
          "input",
          _vm._b(
            {
              ref: "input",
              staticClass: "_sidinnehall_filter",
              attrs: {
                type: "text",
                placeholder: "Sök text och/eller belopp",
                name: "text",
                autocomplete: "off"
              },
              domProps: { value: _vm.vpValue }
            },
            "input",
            _vm.$props,
            false
          )
        ),
        _vm._v(" "),
        _c(
          "svg",
          {
            staticStyle: {
              overflow: "visible",
              "enable-background": "new new 0 0 200 200",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-miterlimit": "10",
              fill: "none",
              stroke: "rgb(152, 151, 148)",
              "stroke-width": "13",
              height: "1.15em",
              width: "1.15em",
              top: "0.42em",
              left: ".35em",
              position: "absolute",
              "pointer-events": "none"
            },
            attrs: {
              version: "1.1",
              x: "0px",
              y: "0px",
              "xml:space": "preserve",
              viewBox: "0 0 200 200"
            }
          },
          [
            _c("g", { attrs: { id: "Forstoringsglas" } }, [
              _c("line", {
                attrs: {
                  id: "Skaft-smalt",
                  x1: "95.76",
                  y1: "112.86",
                  x2: "136.15",
                  y2: "180.05"
                }
              }),
              _vm._v(" "),
              _c("polyline", {
                attrs: {
                  id: "Skaft-tjockt",
                  points:
                    "97.98,111.52 138.37,178.71 133.78,181.47 93.4,114.28 \t"
                }
              }),
              _vm._v(" "),
              _c("circle", {
                attrs: { id: "Glas", cx: "70", cy: "70", r: "50" }
              })
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }